// import "./update.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Select from "react-select";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { teacherInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];

// const TeacherUpdate = ({ title }) => {
//   // Extracting teacherId using regular expressions
//   const location = useLocation();
//   const teacherId = location.pathname.match(/\/update-teacher\/(\d+)/)?.[1];
//   const center_id = localStorage.getItem("center_id");
//   // Initializing state
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedDay, setSelectedDay] = useState(null);
//   const [inputValues, setInputValues] = useState("");
//   const [selectedUser, setSelectedUser] = useState([]);
//   const [useroptions, setUseroptions] = useState([]);
//   const [selectedSubject, setSelectedSubject] = useState([]);
//   const [Subjectoptions, setSubjectoptions] = useState([]);
//   const [selectedClass, setSelectedClass] = useState([]);
//   const [Classoptions, setClassoptions] = useState([]);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchteacher = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/teacher/${teacherId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         const snames = data.data.user_names;
//         const sid = data.data.user_id;
//         // console.log("abbas1",abbas);
//         const namelist = [];
//         const name = snames;
//         console.log(name);
//         const id = sid; // Access the "name" property
//         namelist.push({ value: id, label: name });
//         const Subject = data.data.subject_names;
//         const tid = data.data.subject_id;
//         // console.log("abbas1",abbas);
//         const namelist_t = [];
//         namelist_t.push({ value: tid, label: Subject });
//         const Class = data.data.class_names;
//         const aid = data.data.class_id;
//         // console.log("abbas1",abbas);
//         const namelist_a = [];
//         namelist_a.push({ value: aid, label: Class });
//         setInputValues(data.data);
//         const status = data.data.status;
//         console.log(status);
//         if (status == 1) {
//           setSelectedStatus({ value: status, label: "Active" });
//         } else {
//           setSelectedStatus({ value: status, label: "Inactive" });
//         }
//         setSelectedUser(namelist);
//         setSelectedSubject(namelist_t);
//         setSelectedClass(namelist_a);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (teacherId) {
//       fetchteacher();
//     }
//   }, [teacherId]);
//   // console.log("quiz in a state:", data);

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };

//   const handleUserSelectChange = (selectedOption) => {
//     setSelectedUser(selectedOption);
//     setInputValues({
//       ...inputValues,
//       user_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     user_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const user_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setUseroptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setSelectedSubject(selectedOption);
//     setInputValues({
//       ...inputValues,
//       subject_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     Subject_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const Subject_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setSubjectoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleClassSelectChange = (selectedOption) => {
//     setSelectedClass(selectedOption);
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     Class_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const Class_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setClassoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();

//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("user_id", inputValues.user_id);
//     formData.append("class_id", inputValues.class_id);
//     formData.append("subject_id", inputValues.subject_id);
//     formData.append("status", inputValues.status || 1);
//     // formData.append("logo", file); // Append the file to FormData

//     // Send formData to the server using an HTTP request to update
//     fetch(`${serverUrl}/upd_teacher/${teacherId}`, {
//       method: "PUT",
//       body: formData, // Pass the object as the body
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .then((data) => {
//         if (data.code >= 400) {
//           if (typeof data.message === "object") {
//             Object.entries(data.message).forEach(([field, errors]) => {
//               errors.forEach((errMsg) => {
//                 toast.error(`${field}: ${errMsg}`);
//               });
//             });
//           } else {
//             toast.error(data.message || "Something went wrong.");
//           }

//           // setFilteredOptions(options); // Reset available roles

//           // Force the component to rerender with the empty state
//           setTimeout(() => {}, 500); // Adding timeout to allow state change
//         } else {
//           toast.success("Teacher updated successfully!");
//           setTimeout(() => {
//             navigate("/teacher");
//           }, 1000);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   {teacherInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "subject_id" ? (
//                         <Select
//                           options={Subjectoptions}
//                           name={input.fieldName}
//                           value={selectedSubject}
//                           onChange={handleSubjectSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "user_id" ? (
//                         <Select
//                           options={useroptions}
//                           name={input.fieldName}
//                           value={selectedUser}
//                           onChange={handleUserSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "class_id" ? (
//                         <Select
//                           options={Classoptions}
//                           name={input.fieldName}
//                           value={selectedClass}
//                           onChange={handleClassSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                           // inputMode={input.fieldName === 'no_of_quiz' ? 'numeric' : undefined}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigate(`/categories`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/teacher`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default TeacherUpdate;
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { teacherInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const TeacherUpdate = ({ title }) => {
  const location = useLocation();
  const teacherId = location.pathname.match(/\/update-teacher\/(\d+)/)?.[1];
  const centerId = localStorage.getItem("center_id");
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please login first to access this page");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchTeacher = async () => {
      try {
        const response = await fetch(`${serverUrl}/teacher/${teacherId}`);
        if (!response.ok) throw new Error("Failed to fetch teacher data");
        const data = await response.json();
        
        setInputValues(data.data);
        
        setSelectedStatus(
          data.data.status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" }
        );

        setSelectedUser({
          value: data.data.user_id,
          label: data.data.user_names
        });

        setSelectedSubject({
          value: data.data.subject_id,
          label: data.data.subject_names
        });

        setSelectedClass({
          value: data.data.class_id,
          label: data.data.class_names
        });
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch teacher data");
      }
    };

    if (teacherId) fetchTeacher();
  }, [teacherId]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        // Fetch users
        const usersRes = await fetch(`${serverUrl}/user_ids/${centerId}`);
        const usersData = await usersRes.json();
        setUserOptions(usersData.data.map(u => ({ value: u.id, label: u.name })));

        // Fetch subjects
        const subjectsRes = await fetch(`${serverUrl}/subject_ids/${centerId}`);
        const subjectsData = await subjectsRes.json();
        setSubjectOptions(subjectsData.data.map(s => ({ value: s.id, label: s.name })));

        // Fetch classes
        const classesRes = await fetch(`${serverUrl}/class_ids/${centerId}`);
        const classesData = await classesRes.json();
        setClassOptions(classesData.data.map(c => ({ value: c.id, label: c.name })));
      } catch (error) {
        console.error("Error fetching options:", error);
        toast.error("Failed to load options");
      }
    };

    fetchOptions();
  }, [centerId]);

  const handleSelectChange = (field, selectedOption) => {
    const setters = {
      status: setSelectedStatus,
      user_id: setSelectedUser,
      subject_id: setSelectedSubject,
      class_id: setSelectedClass
    };

    setters[field](selectedOption);
    setInputValues({
      ...inputValues,
      [field]: selectedOption.value
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("center_id", centerId);
    formData.append("user_id", inputValues.user_id);
    formData.append("class_id", inputValues.class_id);
    formData.append("subject_id", inputValues.subject_id);
    formData.append("status", inputValues.status || 1);

    try {
      const response = await fetch(`${serverUrl}/upd_teacher/${teacherId}`, {
        method: "PUT",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach(errMsg => toast.error(`${field}: ${errMsg}`));
          });
        } else {
          toast.error(data.message || "Update failed");
        }
      } else {
        toast.success("Teacher updated successfully!");
        setTimeout(() => navigate("/teacher"), 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  const renderSelectField = (field, options, value) => (
    <Select
      options={options}
      value={value}
      onChange={(option) => handleSelectChange(field, option)}
      required
      className="selectInput"
      styles={{
        control: (base) => ({
          ...base,
          minHeight: '46px',
          borderColor: '#e2e8f0',
          '&:hover': { borderColor: '#cbd5e0' }
        }),
        valueContainer: (base) => ({
          ...base,
          padding: '2px 8px'
        }),
        input: (base) => ({
          ...base,
          margin: '0',
          padding: '0'
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: '44px'
        })
      }}
    />
  );

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>

                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {teacherInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "status" ? (
                              renderSelectField("status", statusOptions, selectedStatus)
                            ) : input.fieldName === "user_id" ? (
                              renderSelectField("user_id", userOptions, selectedUser)
                            ) : input.fieldName === "subject_id" ? (
                              renderSelectField("subject_id", subjectOptions, selectedSubject)
                            ) : input.fieldName === "class_id" ? (
                              renderSelectField("class_id", classOptions, selectedClass)
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ 
                      display: "flex", 
                      justifyContent: "center", 
                      gap: 3, 
                      mt: 4, 
                      pb: 2 
                    }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/teacher")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update Teacher
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default TeacherUpdate;